import React from 'react'
import { AbilityContext } from './AbilityContext'
import { IRealmAuth } from './Authorization'
import { Ability } from '@casl/ability'
import { AbilityInitializer } from './AbilityInitializer'

export interface IAbilityProvider {
  restrictions: IRealmAuth
    children: React.ReactElement<any>
}

export interface IAbilityInitializer extends IAbilityProvider{
    onUpdate: (ability: any) => void
}

const _ability = new Ability([], {})

export const AbilityProvider: React.FC<IAbilityProvider> = (props) => {
  const { restrictions } = props
    const [ability, setAbility] = React.useState(_ability)
  return (
    <AbilityContext.Provider value={ability}>
      <AbilityInitializer
          restrictions={restrictions}
          onUpdate={(ab: any) => setAbility(ab)}
      >
        {props.children}
      </AbilityInitializer>
    </AbilityContext.Provider>
  )
}
